import { createClient } from '@supabase/supabase-js';

// Configuration Supabase
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

// Créer le client Supabase
export const supabase = createClient(supabaseUrl, supabaseKey);

// Fonction pour vérifier si Supabase est configuré
export const isSupabaseConfigured = () => {
  return supabaseUrl !== 'YOUR_SUPABASE_URL' && 
         supabaseKey !== 'YOUR_SUPABASE_ANON_KEY' &&
         supabaseUrl && 
         supabaseKey;
};

// Fonction utilitaire pour la gestion des erreurs Supabase
export const handleSupabaseError = (error) => {
  console.error('Erreur Supabase:', error);
  return {
    success: false,
    error: error.message || 'Erreur inconnue'
  };
};

// Fonctions spécifiques pour la table 'smartex'
export const smartexService = {
  // Récupérer tous les exercices pour une classe donnée
  async getExercisesByClass(className = 'Quatrième', isActive = true) {
    try {
      const { data, error } = await supabase
        .from('smartex')
        .select('*')
        .eq('class_level', className)
        .eq('is_active', isActive)
        .order('id', { ascending: true });

      if (error) throw error;
      return { success: true, data: data || [] };
    } catch (error) {
      return handleSupabaseError(error);
    }
  },

  // Récupérer un exercice spécifique par ID
  async getExerciseById(id) {
    try {
      const { data, error } = await supabase
        .from('smartex')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      return handleSupabaseError(error);
    }
  },

  // Récupérer les exercices par chapitre
  async getExercisesByChapter(chapterName, className = 'Quatrième') {
    try {
      const { data, error } = await supabase
        .from('smartex')
        .select('*')
        .eq('chapter', chapterName)
        .eq('class_level', className)
        .eq('is_active', true)
        .order('id', { ascending: true });

      if (error) throw error;
      return { success: true, data: data || [] };
    } catch (error) {
      return handleSupabaseError(error);
    }
  },

  // Récupérer toutes les classes disponibles
  async getAvailableClasses() {
    try {
      const { data, error } = await supabase
        .from('smartex')
        .select('class_level')
        .eq('is_active', true);

      if (error) throw error;
      
      // Extraire les classes uniques
      const uniqueClasses = [...new Set(data.map(item => item.class_level))];
      return { success: true, data: uniqueClasses };
    } catch (error) {
      return handleSupabaseError(error);
    }
  },

  // Récupérer tous les chapitres pour une classe
  async getChaptersByClass(className = 'Quatrième') {
    try {
      const { data, error } = await supabase
        .from('smartex')
        .select('chapter')
        .eq('class_level', className)
        .eq('is_active', true);

      if (error) throw error;
      
      // Extraire les chapitres uniques
      const uniqueChapters = [...new Set(data.map(item => item.chapter))];
      return { success: true, data: uniqueChapters };
    } catch (error) {
      return handleSupabaseError(error);
    }
  }
};

export default supabase;
